var _defs, _line, _line2, _line3, _line4, _line5, _line6, _path, _circle, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 352 352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#231f20;stroke-linecap:round;stroke-miterlimit:10;stroke-width:18px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 292.26,
    y1: 102.59,
    x2: 270.43,
    y2: 102.59
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 225.49,
    y1: 102.59,
    x2: 56.34,
    y2: 102.59
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 292.26,
    y1: 176.69,
    x2: 128.47,
    y2: 176.69
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.53,
    y1: 176.69,
    x2: 56.34,
    y2: 176.69
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 292.26,
    y1: 249.14,
    x2: 219.02,
    y2: 249.14
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 174.09,
    y1: 249.14,
    x2: 56.34,
    y2: 249.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.43,102.59A22.47,22.47,0,1,1,248,80.12,22.47,22.47,0,0,1,270.43,102.59Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 106,
    cy: 176.69,
    r: 22.47,
    transform: "matrix(0.92, -0.38, 0.38, 0.92, -59.55, 54.01)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219,249.14a22.47,22.47,0,1,1-22.47-22.46A22.47,22.47,0,0,1,219,249.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.f7f6b67c13b73f08fea98c985fec3dc1.svg";
export { ForwardRef as ReactComponent };